import CaptivePortalInstructions from './CaptivePortalInstructions';

export default CaptivePortalInstructions;
